"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerBuilder = void 0;

var _auth = require("@nextcloud/auth");

class LoggerBuilder {
  constructor(factory) {
    this.context = {};
    this.factory = factory;
  }

  setApp(appId) {
    this.context.app = appId;
    return this;
  }

  setUid(uid) {
    this.context.uid = uid;
    return this;
  }

  detectUser() {
    const user = (0, _auth.getCurrentUser)();

    if (user !== null) {
      this.context.uid = user.uid;
    }

    return this;
  }

  build() {
    return this.factory(this.context);
  }

}

exports.LoggerBuilder = LoggerBuilder;
//# sourceMappingURL=LoggerBuilder.js.map